import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withUpdateActionTime from '../with-action-time';
import AnalyticsPage from './analytics';

const enhance = compose(
	withUpdateActionTime,
	withState('tabIndex', 'setTabIndex', 0)
);

export default enhance(AnalyticsPage);



// WEBPACK FOOTER //
// ./src/client/pages/admin/analytics/index.js